/* Maison Poster — animations
   - poster de la bannière qui s'écrit tout seul (coloris et cadres qui changent)
   - apparitions au défilement, images qui « se développent » comme une photo
   - cartes qui s'inclinent comme un cadre au mur, en-tête compact au défilement
   Tout est coupé si le visiteur a réduit les animations sur son appareil. */
(function () {
  'use strict';

  var html = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var enabled = html.classList.contains('anim') && !reduce;
  if (!enabled) html.classList.remove('anim');

  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  /* ---------- 1. Poster vivant de la bannière ---------- */
  var SEQ = [
    { theme: 'ivoire', frame: 'bois',  family: 'Martin', names: ['Léa', 'Hugo', 'Emma'],          year: '2015', label: 'Ivoire · cadre bois naturel' },
    { theme: 'sauge',  frame: 'blanc', family: 'Rochat', names: ['Julie', 'Marc', 'Inès', 'Léo'], year: '2012', label: 'Sauge · cadre blanc' },
    { theme: 'nuit',   frame: 'noir',  family: 'Dubois', names: ['Camille', 'Noah'],             year: '2009', label: 'Nuit · cadre noir' },
    { theme: 'ivoire', frame: 'noir',  family: 'Favre',  names: ['Anna', 'Luca', 'Mia'],          year: '2018', label: 'Ivoire · cadre noir' },
    { theme: 'sauge',  frame: 'bois',  family: 'Berset', names: ['Chloé', 'Tom'],                 year: '2021', label: 'Sauge · cadre bois naturel' }
  ];

  function heroLive(root) {
    var MP = window.MaisonPoster;
    var canvas = root.querySelector('canvas');
    var frame = root.querySelector('[data-hero-frame]');
    var caption = root.querySelector('[data-hero-caption]');
    if (!MP || !canvas || !frame) return;
    root.classList.add('is-pending');
    var readyDone = false;
    function ready() {
      if (readyDone) return;
      readyDone = true;
      root.classList.remove('is-pending');
      root.classList.add('is-ready');
    }
    setTimeout(ready, 3000);   // sécurité : le cadre s'affiche même si une police tarde

    var d = root.dataset;
    function face(fam, url, desc) {
      if (!url || typeof FontFace === 'undefined') return Promise.resolve();
      return new FontFace(fam, 'url(' + url + ')', desc).load().then(function (f) { document.fonts.add(f); }).catch(function () {});
    }
    var fonts = Promise.all([
      face('PCormorant', d.fontSerif, { weight: '500' }),
      face('PCormorant', d.fontSerifSb, { weight: '600' }),
      face('PCormorant', d.fontSerifIt, { weight: '500', style: 'italic' }),
      face('PJost', d.fontSans, { weight: '400' }),
      face('PJost', d.fontSansMd, { weight: '500' })
    ]);

    var st = { mode: 'laurier', fmt: { w: 300, h: 400 }, preview: false, theme: 'ivoire', family: '', names: [], year: '', layers: [] };
    var ZW = '​';   // nom « vide » pendant l'écriture

    function size() {
      var w = Math.round((canvas.getBoundingClientRect().width || 360) * Math.min(window.devicePixelRatio || 1, 2));
      w = Math.max(300, Math.min(1200, w));
      if (canvas.width !== w) { canvas.width = w; canvas.height = Math.round(w * 4 / 3); }
    }
    function paint() { size(); MP.render(canvas, st, canvas.width / 300, 0); }
    function apply(s, full) {
      st.theme = s.theme; st.year = s.year;
      st.family = full ? s.family : ZW;
      st.names = full ? s.names.slice() : [ZW];
      frame.className = frame.className.replace(/perso-frame--\w+/, 'perso-frame--' + s.frame);
      if (caption) caption.textContent = s.label;
    }
    function nudge() {
      frame.classList.remove('is-nudge');
      void frame.offsetWidth;
      frame.classList.add('is-nudge');
    }

    var visible = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(root);
    }
    async function wait(ms) {
      await sleep(ms);
      while (!visible || document.hidden) await sleep(300);
    }

    window.addEventListener('resize', function () { paint(); });

    fonts.then(async function () {
      if (!enabled) { apply(SEQ[0], true); paint(); ready(); return; }
      apply(SEQ[0], false); paint();
      ready();
      await sleep(900);   // laisse le cadre s'accrocher
      var i = 0;
      for (;;) {
        var s = SEQ[i % SEQ.length];
        if (i > 0) {
          canvas.classList.add('is-fading');
          await sleep(320);
          apply(s, false); paint(); nudge();
          canvas.classList.remove('is-fading');
          await wait(450);
        }
        // le nom de famille s'écrit lettre par lettre
        for (var k = 1; k <= s.family.length; k++) {
          st.family = s.family.slice(0, k); paint();
          await wait(k === 1 ? 160 : 115);
        }
        await wait(250);
        // puis les prénoms apparaissent un à un
        for (var n = 1; n <= s.names.length; n++) {
          st.names = s.names.slice(0, n); paint();
          await wait(280);
        }
        await wait(2600);
        i++;
      }
    });
  }

  /* ---------- 2. Apparitions au défilement ---------- */
  var GROUPS = [
    ['.section__header', ''],
    ['.hero__text > *', ''],
    ['.benefit', ''],
    ['.step', 'rv-stamp'],
    ['.card', 'rv-dev'],
    ['.image-text__media', 'rv-dev'],
    ['.image-text > div:not(.image-text__media)', ''],
    ['.faq details', ''],
    ['.newsletter', ''],
    ['.ornament', 'rv-line'],
    ['.perso-examples', 'rv-dev'],
    ['.footer__grid > *', '']
  ];

  function reveals() {
    var items = [];
    GROUPS.forEach(function (g) {
      document.querySelectorAll(g[0]).forEach(function (el) {
        if (el.closest('.product__info') || el.classList.contains('rv')) return;
        el.classList.add('rv');
        if (g[1]) el.classList.add(g[1]);
        // décalage en cascade entre éléments frères
        var idx = 0, sib = el.previousElementSibling;
        while (sib && idx < 6) { if (sib.classList.contains('rv')) idx++; sib = sib.previousElementSibling; }
        el.style.setProperty('--rv-delay', (idx * 90) + 'ms');
        items.push(el);
      });
    });
    if (!('IntersectionObserver' in window)) { items.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 3. Cartes : cadre qui s'incline et capte la lumière ---------- */
  function tilt() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.querySelectorAll('.card__media').forEach(function (m) {
      m.classList.add('tilt');
      m.addEventListener('pointermove', function (e) {
        var r = m.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        m.style.setProperty('--ry', ((x - 0.5) * 7).toFixed(2) + 'deg');
        m.style.setProperty('--rx', ((0.5 - y) * 7).toFixed(2) + 'deg');
        m.style.setProperty('--gx', (x * 100).toFixed(1) + '%');
        m.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
      });
      m.addEventListener('pointerleave', function () {
        m.style.setProperty('--rx', '0deg'); m.style.setProperty('--ry', '0deg');
      });
    });
  }

  /* ---------- 4. En-tête compact au défilement ---------- */
  function header() {
    var h = document.querySelector('[data-header]');
    if (!h) return;
    var on = false;
    // hystérésis : évite que l'en-tête oscille quand sa hauteur change près du seuil
    function check() {
      var y = window.scrollY;
      var s = on ? y > 16 : y > 96;
      if (s !== on) { on = s; h.classList.toggle('is-scrolled', s); }
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  function boot() {
    document.querySelectorAll('[data-hero-live]').forEach(heroLive);
    if (!enabled) return;
    reveals();
    tilt();
    header();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
